var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.state == 0)?_c('HelloWorld',{attrs:{"msg":"Welcome to Your Vue.js App"}}):_vm._e(),(_vm.state == 1)?_c('Index'):_vm._e(),(_vm.state == 2)?_c('Wx'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }